const moduleOrder = [
  "main"
]
export default moduleOrder



// WEBPACK FOOTER //
// ./src/modules/_order.js